// Anglar
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// Layout Directives
// Services
import { ContentAnimateDirective, FirstLetterPipe, GetObjectPipe, HeaderDirective, JoinPipe, MenuDirective, OffcanvasDirective, SafePipe, ScrollTopDirective, SparklineChartDirective, StickyDirective, TabClickEventDirective, TimeElapsedPipe, ToggleDirective } from './_base/layout';
import { CaptionMlPipe } from './_base/layout/pipes/caption-ml.pipe';
import { FileNameFromUrlPipe } from './_base/layout/pipes/file-name-from-url.pipe';
import { SearchPipe } from './_base/layout/pipes/search.pipe';
import { TagFilterPipe } from './_base/layout/pipes/tag-filter.pipe';
import { TagNamePipe } from './_base/layout/pipes/tag-name.pipe';
import { TagExistPipe } from './_base/layout/pipes/tag-exist.pipe';
import { PrinterFinderPipe } from './_base/layout/pipes/printer-finder.pipe';
import { PrinterSetupFinderPipe } from './_base/layout/pipes/printer-setup-finder.pipe';
import { PrinterAliasControllerPipe } from './_base/layout/pipes/printer-alias-controller.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    // directives
    ScrollTopDirective,
    HeaderDirective,
    OffcanvasDirective,
    ToggleDirective,
    MenuDirective,
    TabClickEventDirective,
    SparklineChartDirective,
    ContentAnimateDirective,
    StickyDirective,
    // pipes
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    SafePipe,
    FirstLetterPipe,
    CaptionMlPipe,
    FileNameFromUrlPipe,
    SearchPipe,
    PrinterFinderPipe,
    PrinterSetupFinderPipe,
    PrinterAliasControllerPipe
  ],
  exports: [
    // directives
    ScrollTopDirective,
    HeaderDirective,
    OffcanvasDirective,
    ToggleDirective,
    MenuDirective,
    TabClickEventDirective,
    SparklineChartDirective,
    ContentAnimateDirective,
    StickyDirective,
    // pipes
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    SafePipe,
    FirstLetterPipe,
    CaptionMlPipe,
    FileNameFromUrlPipe,
    SearchPipe,
    PrinterFinderPipe,
    PrinterSetupFinderPipe,
    PrinterAliasControllerPipe
  ],
  providers: []
})
export class CoreModule {
}
